module.exports = __webpack_public_path__ + "img/IT0000159413545.19468400.png";